import { createAsyncThunk } from "@reduxjs/toolkit";
import type ApiResponse from "../../services/api/types/ApiResponse";
import type MastResultDto from "../../dto/calculations/MastResultDto";
import type DrillholeDto from "../../dto/calculations/DrillholeDto";
import type { RootState } from "../../store";

interface ValidateDrillholesCodeData {
  mastId: string;
  validateDrillholesCode: (drillholes: DrillholeDto[]) => Promise<ApiResponse<void>>;
}

export const validateDrillholesCodeWrapper = createAsyncThunk(
  `constructionCalculationsNew/validateDrillholesCode`,
  async (
    data: ValidateDrillholesCodeData,
    {getState},
  ): Promise<{mastId: string; isDrillholesCodeValid: boolean}> => {
    const state = getState() as RootState;
    const mastId = data.mastId;
    const currentMast =
      state.constructionCalculationsNew.selectedCalculationResults?.mastResults?.find(
        (m: MastResultDto) => m.mastId === mastId,
      );

    const drillholes = currentMast?.drillholesCode.drillholes ?? [];
    const drillholesCodeValidationResult = await data.validateDrillholesCode(drillholes);
    const isDrillholesCodeValid = drillholesCodeValidationResult.errors === undefined;

    return {mastId, isDrillholesCodeValid};
  },
);
